import * as React from "react";
import colorsStore from "shared/store/colorsStore";
import styles from "./input.module.css";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

interface CustomCSSProperties extends React.CSSProperties {
  "--input-ring-color"?: string;
  "--input-ring-offset-color"?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const colorsConfig = colorsStore((state) => state.colorsConfigStore);
    const inputStyle: CustomCSSProperties = {
      "--input-ring-color": colorsConfig.main,
      "--input-ring-offset-color": colorsConfig.main,
      backgroundColor: colorsConfig.white,
      color: colorsConfig.finecoBlack,
      borderColor: colorsConfig.gray2,
      ...props.style,
    };

    return (
      <input
        type={type}
        className={`${styles.input} ${className || ""}`}
        ref={ref}
        {...props}
        style={inputStyle}
      />
    );
  },
);

Input.displayName = "Input";

export { Input };
